module.exports = __webpack_public_path__ + "img/kos_yes.1506399d.png";